import { FC, ReactNode } from 'react';
import { ScrollShadow } from "@heroui/react";

interface HorizontalScrollProps {
  children: ReactNode;
  className?: string;
  itemWidth?: string;
}

export const HorizontalScroll: FC<HorizontalScrollProps> = ({
  children,
  className = '',
  itemWidth = '300px',
}) => {
  const isSingleItem = !Array.isArray(children) || children.length === 1;

  return (
    <ScrollShadow
      isEnabled={!isSingleItem}
      size={20}
      orientation="horizontal"
      className={`w-full ${className}`}
    >
      <div 
        className="flex gap-4 pb-4 w-full"
        style={{ 
          overflow: 'auto',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
        }}
      >
        {Array.isArray(children)
          ? children.map((child, index) => (
            <div
              key={index}
              style={{ 
                flex: isSingleItem ? '1 1 100%' : 'none',
                minWidth: itemWidth,
                width: itemWidth,
                maxWidth: isSingleItem ? '100%' : itemWidth
              }}
              className={isSingleItem ? 'max-w-screen-lg mx-auto' : ''}
            >
              {child}
            </div>
          ))
          : <div 
              style={{ 
                flex: '1 1 100%',
                width: '100%',
                maxWidth: '100%'
              }}
              className="max-w-screen-lg mx-auto"
            >
              {children}
            </div>
        }
      </div>
    </ScrollShadow>
  );
};

export default HorizontalScroll; 